import type { SubmissionDto } from "../../services/ApiService";
import type { Submission, SubmissionIntegrationStatus } from "../../types/Submission";
import SubmissionId from "../../state/SubmissionId";
import TaskId from "../../state/TaskId";
import { isNil } from "lodash-es";

export const toSubmission = (dto: SubmissionDto, status?: SubmissionIntegrationStatus): Submission => ({
  id: SubmissionId.from(dto.id),
  info: {
    username: dto.info.userId,
    date: new Date(dto.info.date),
    summary: dto.info.summary,
  },
  data: dto.data,
  meta: {
    serialNumber: dto.meta.serialNumber,
    registrationDate: new Date(parseInt(dto.meta.registrationDate)),
    taskId: isNil(dto.meta.taskId) ? undefined : TaskId.from(dto.meta.taskId),
    location: dto.meta.location,
    device: {
      name: dto.meta.device.name,
      network: dto.meta.device.network,
      appVersion: dto.meta.device.appVersion,
    },
  },
  integrationStatus: status || "OPEN",
  mailStatuses: dto.mailStatuses,
});
